export const ROUTES = {
  HOME: '/',
  LIVE_MEETING: '/live',
  MEETING_STATS: '/meetingstats',
  PREVIEW_CASE: '/previewCase',
  ACCESS_LINK: '/access-link',

  REGISTER: '/register',

  ADMIN: '/admin',
  ADMIN_CASE_LIST: '/admin/cases',
  // ADMIN_CASE_VIEW: '/admin/view/case',
  ADMIN_TEST: '/admin/test',

  ADMIN_USER_LIST: '/admin/users',

  ADMIN_CLIENTS: '/admin/clients',
  ADMIN_TEAMS: '/admin/teams',
  ADMIN_MEETING_LIST: '/admin/meetings',
  ADMIN_MASTERCLASS_LIST: '/admin/masterclasses',
  ADMIN_CASE_CLUSTER_LIST: '/admin/caseClusters',
  ADMIN_CLICKUP: '/admin/clickup',
  ADMIN_SALES: '/admin/sales',
};
